import type { CopyShape } from "../../intl";

import type { FORMAT_LIMIT_COPY_PT_BR } from "../format-limit.copy";

export const FORMAT_LIMIT_COPY_EN_US: CopyShape<
  typeof FORMAT_LIMIT_COPY_PT_BR
> = {
  disabled: "—",
  included: "included",
  unlimited: "unlimited",
  trialOnly: "in the trial",
  trialWithLimit: (limit: number): string => `${limit} in the trial`,
  hours: (stored: number): string => `${stored}h`,
  hoursAsDays: (days: number): string => `${days} days`,
  days: (stored: number): string => `${stored} days`,
  trialDay: "1 day",
  trialDays: (stored: number): string => `${stored} days`,
  interval: (value: string): string => `every ${value}`,
  monthly: (counted: string): string => `${counted} /mo`,
  total: (counted: string): string => `${counted} total`,
};
